// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	background: var(--background);
	height: 80px;
}

.header {
	max-width: 1340px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	gap: 24px;
	align-items: center;
	padding: 0 20px;
}

.header__logo-block {
	width: 250px;
}

.header__logo-block img {
	max-height: 48px;
}

.header__nav {
	display: flex;
	align-items: center;
	gap: 40px;
}

.header__nav-item {
	color: var(--text) !important;
	font-size: 16px;
	font-family: "Poppins", sans-serif;
	height: 40px;
	border-radius: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 40px;
	transition: 0.3s;
}

.header__nav-item:hover {
	color: var(--background) !important;
	background-color: var(--button);
	transition: 0.3s;
}

.header__nav-item.active {
	color: var(--background) !important;
	background-color: var(--button);
	transition: 0.3s;
	font-weight: 400 !important;
}

.header__nav-item.active::before {
	content: none !important;
}

.header__register-block {
	display: flex;
	align-items: center;
	gap: 24px;
}

.header__login-button {
	background-color: unset;
	cursor: pointer;
	border: none;
	font-size: 16px;
}

.header__register-button {
	display: flex;
	align-items: center;
	background-color: transparent;
	justify-content: center;
	cursor: pointer;
	padding: 0 !important;
}

.header__register-button:hover .register-button__main,
.header__register-button:hover .register-button__arrow,
.header__register-button:hover .register-button__middle {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.register-button__main {
	background-color: var(--button);
	width: 130px;
	height: 40px;
	border-radius: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--background);
	font-size: 16px;
	transition: 0.3s;
}

.register-button__middle {
	width: 15px;
	background-color: var(--button);
	height: 26px;
	margin-left: -7px;
	position: relative;
	transition: 0.3s;
}

.register-button__arrow {
	height: 40px;
	width: 40px;
	border-radius: 100%;
	background-color: var(--button);
	margin-left: -10px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.3s;
}

.register-button-middle__top-circle {
	position: absolute;
	top: -6px;
	left: 2px;
	width: 8px;
	height: 8px;
	background-color: var(--background);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 3px;
}

.register-button-middle__bottom-circle {
	position: absolute;
	bottom: -6px;
	left: 2px;
	width: 8px;
	height: 8px;
	background-color: var(--background);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 3px;
}

.header__mobile-expand {
	display: none;
}

.header__nav-item.mobile-only {
	display: none;
}

@media (max-width: 1100px) {
	.header__nav {
		gap: 12px;
	}

	.header__logo-block {
		width: 200px;
	}
}

@media (max-width: 950px) {
	.header__register-block {
		display: none;
		align-items: center;
	}

	.header__mobile-expand {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50px;
		height: 70px;
		cursor: pointer;
		margin-right: -10px;
	}

	.header__nav {
		display: none !important;
		align-items: center;
		gap: 40px;
	}

	.header__nav.expanded {
		display: flex !important;
		flex-direction: column;
		position: absolute;
		top: 70px;
		left: 0;
		width: 100%;
		background-color: var(--background);
		z-index: 1000;
		height: calc(100dvh - 70px);
		padding: 40px 0;
	}

	.header-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--background);
		height: 70px;
		position: sticky;
		z-index: 5;
		width: 100%;
		top: 0;
		left: 0;
	}

	.header__logo-block img {
		max-height: 45px;
	}

	.header__nav-item.mobile-only {
		display: flex;
	}
}

.link {
	display: block;
	padding: 20px 10px;
	color: #494949 !important;
	position: relative;
	font-family: "Poppins", sans-serif;
	font-size: 16px !important;
	font-weight: 400 !important;
	line-height: 24px !important;
}

.active {
	font-family: "Poppins", sans-serif;
	font-weight: 700 !important;
	font-size: 16px !important;
	color: #203f70 !important;
}

.active::before {
	position: absolute;
	height: 9px;
	width: 9px;
	border-radius: 5px;
	bottom: 10px;
	left: 0;
	right: 0;
	margin: auto;
	content: "";
	background: #203f70;
	transition: width 0.4s;
	color: #203f70 !important;
}

.login {
	font-family: "Poppins", sans-serif;
	font-size: 16px;
	font-weight: 500;
	line-height: 38px;
	color: #494949 !important;
	display: flex;
	align-items: center;
	font-size: 16px;
}

.register {
	display: flex;
	align-items: center;
	font-size: 16px;
	flex-direction: row;
	justify-content: center;
	padding: 18px;
	width: 114px;
	height: 38px;
	background: var(--button-background);
	border-radius: 36px;
	font-family: "Poppins";
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	color: #000000 !important;
}

.user-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	padding: 0;
	height: 1px;
	background-color: white;
}

.user-header__content {
	display: flex;
	align-items: center;
	gap: 20px;
	position: absolute;
	top: 16px;
	right: 24px;
}

.user-header__switch {
	width: 48px;
	height: 24px;
	border-radius: 20px;
	overflow: hidden;
	position: relative;
	object-fit: cover;
	cursor: pointer;
}

.user-header__switch-circle {
	position: absolute;
	left: 2px;
	top: 2px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: white;
	cursor: pointer;
}

.user-header__switch-circle.zh {
	left: unset;
	right: 2px;
}

.user-header__switch-circle.en {
	left: 2px;
}

.user-header__switch-image {
	width: 100%;
}

.dashboard-header__notifications {
	width: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid #e6e6e6;
	border-radius: 100%;
	background-color: white;
	cursor: pointer;
}

.dashboard-header__notifications.notification-unread {
	background-color: #feeced;
	border: 1px solid #feeced;
}

.user-header-dropdown,
.user-header-dropdown.show,
.user-header-dropdown:active,
.user-header-dropdown:hover,
.user-header-dropdown:focus-visible {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

.user-header-dropdown::after {
	content: unset;
}

.user-header-dropdown-menu {
	left: unset !important;
	right: 0% !important;
}

.notifications-container {
	position: absolute;
	width: 340px;
	height: 500px;
	background-color: #ffffff;
	right: 10px;
	z-index: 1001;
	border-radius: 10px;
	top: 72px;
	overflow: hidden;
	border: 1px solid #e6e6e6;
	box-shadow: 0 0 15px 2px #0c030322;
}

.notification-body {
	height: calc(100% - 57px);
	overflow-y: auto;
	background-color: #ffffff;
}

.notification-body::-webkit-scrollbar {
	width: 7px;
	background-color: transparent;
}

.notification-body::-webkit-scrollbar-thumb {
	background-color: #333333;
	border-radius: 10px;
	margin-top: 10px;
}

.notification-body::-webkit-scrollbar-track {
	background-color: transparent;
}

.notifications-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	border-bottom: 1px solid #e6e6e6;
}

.notification-block {
	display: flex;
	flex-direction: row;
	align-items: start;
	justify-content: space-between;
	width: 100%;
	padding: 10px;
	background-color: white;
	padding-bottom: 35px;
	position: relative;
	border-bottom: 1px solid #e6e6e6;
}

.notification-type-dot {
	min-width: 10px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-top: 7px;
}

.notification-type-dot.info {
	background-color: #4db8ff;
}

.notification-type-dot.warning {
	background-color: #ffc107;
}

.notification-type-dot.error {
	background-color: #f44336;
}

.notification-created-at {
	position: absolute;
	left: 35px;
	bottom: 10px;
	font-size: 14px;
	color: #808080;
}

.notifications-title {
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
}

.notification-info {
	display: flex;
	align-items: start;
	gap: 16px;
	width: 90%;
}

.notification-icon {
	margin-right: 5px;
	margin-top: 1px;
}

.notification-text {
	color: #333333;
	word-break: break-word;
}

.notifications-count-block {
	width: 22px;
	height: 22px;
	background-color: #d24023;
	color: white;
	position: absolute;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 12px;
	top: 5px;
	right: 5px;
	border: 1px solid white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/Header/Header.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,kCAAkC;CAClC,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,uBAAuB;CACvB,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,6BAA6B;CAC7B,uBAAuB;CACvB,eAAe;CACf,qBAAqB;AACtB;;AAEA;;;CAGC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,YAAY;CACZ,YAAY;CACZ,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,wBAAwB;CACxB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,+BAA+B;CAC/B,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,SAAS;CACV;;CAEA;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;CACV;;CAEA;EACC,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,2BAA2B;EAC3B,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,MAAM;EACN,OAAO;CACR;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,kCAAkC;CAClC,0BAA0B;CAC1B,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,kCAAkC;CAClC,2BAA2B;CAC3B,0BAA0B;CAC1B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,YAAY;CACZ,YAAY;CACZ,oCAAoC;CACpC,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;;;;CAKC,wCAAwC;CACxC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,gBAAgB;CAChB,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,UAAU;CACV,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,8BAA8B;CAC9B,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,QAAQ;CACR,UAAU;CACV,uBAAuB;AACxB","sourcesContent":[".header-wrapper {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: var(--background);\n\theight: 80px;\n}\n\n.header {\n\tmax-width: 1340px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 24px;\n\talign-items: center;\n\tpadding: 0 20px;\n}\n\n.header__logo-block {\n\twidth: 250px;\n}\n\n.header__logo-block img {\n\tmax-height: 48px;\n}\n\n.header__nav {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 40px;\n}\n\n.header__nav-item {\n\tcolor: var(--text) !important;\n\tfont-size: 16px;\n\tfont-family: \"Poppins\", sans-serif;\n\theight: 40px;\n\tborder-radius: 30px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0 40px;\n\ttransition: 0.3s;\n}\n\n.header__nav-item:hover {\n\tcolor: var(--background) !important;\n\tbackground-color: var(--button);\n\ttransition: 0.3s;\n}\n\n.header__nav-item.active {\n\tcolor: var(--background) !important;\n\tbackground-color: var(--button);\n\ttransition: 0.3s;\n\tfont-weight: 400 !important;\n}\n\n.header__nav-item.active::before {\n\tcontent: none !important;\n}\n\n.header__register-block {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 24px;\n}\n\n.header__login-button {\n\tbackground-color: unset;\n\tcursor: pointer;\n\tborder: none;\n\tfont-size: 16px;\n}\n\n.header__register-button {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: transparent;\n\tjustify-content: center;\n\tcursor: pointer;\n\tpadding: 0 !important;\n}\n\n.header__register-button:hover .register-button__main,\n.header__register-button:hover .register-button__arrow,\n.header__register-button:hover .register-button__middle {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.register-button__main {\n\tbackground-color: var(--button);\n\twidth: 130px;\n\theight: 40px;\n\tborder-radius: 100px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: var(--background);\n\tfont-size: 16px;\n\ttransition: 0.3s;\n}\n\n.register-button__middle {\n\twidth: 15px;\n\tbackground-color: var(--button);\n\theight: 26px;\n\tmargin-left: -7px;\n\tposition: relative;\n\ttransition: 0.3s;\n}\n\n.register-button__arrow {\n\theight: 40px;\n\twidth: 40px;\n\tborder-radius: 100%;\n\tbackground-color: var(--button);\n\tmargin-left: -10px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: 0.3s;\n}\n\n.register-button-middle__top-circle {\n\tposition: absolute;\n\ttop: -6px;\n\tleft: 2px;\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: var(--background);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 3px;\n}\n\n.register-button-middle__bottom-circle {\n\tposition: absolute;\n\tbottom: -6px;\n\tleft: 2px;\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: var(--background);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 3px;\n}\n\n.header__mobile-expand {\n\tdisplay: none;\n}\n\n.header__nav-item.mobile-only {\n\tdisplay: none;\n}\n\n@media (max-width: 1100px) {\n\t.header__nav {\n\t\tgap: 12px;\n\t}\n\n\t.header__logo-block {\n\t\twidth: 200px;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.header__register-block {\n\t\tdisplay: none;\n\t\talign-items: center;\n\t}\n\n\t.header__mobile-expand {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 50px;\n\t\theight: 70px;\n\t\tcursor: pointer;\n\t\tmargin-right: -10px;\n\t}\n\n\t.header__nav {\n\t\tdisplay: none !important;\n\t\talign-items: center;\n\t\tgap: 40px;\n\t}\n\n\t.header__nav.expanded {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column;\n\t\tposition: absolute;\n\t\ttop: 70px;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tbackground-color: var(--background);\n\t\tz-index: 1000;\n\t\theight: calc(100dvh - 70px);\n\t\tpadding: 40px 0;\n\t}\n\n\t.header-wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: var(--background);\n\t\theight: 70px;\n\t\tposition: sticky;\n\t\tz-index: 5;\n\t\twidth: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.header__logo-block img {\n\t\tmax-height: 45px;\n\t}\n\n\t.header__nav-item.mobile-only {\n\t\tdisplay: flex;\n\t}\n}\n\n.link {\n\tdisplay: block;\n\tpadding: 20px 10px;\n\tcolor: #494949 !important;\n\tposition: relative;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 16px !important;\n\tfont-weight: 400 !important;\n\tline-height: 24px !important;\n}\n\n.active {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 700 !important;\n\tfont-size: 16px !important;\n\tcolor: #203f70 !important;\n}\n\n.active::before {\n\tposition: absolute;\n\theight: 9px;\n\twidth: 9px;\n\tborder-radius: 5px;\n\tbottom: 10px;\n\tleft: 0;\n\tright: 0;\n\tmargin: auto;\n\tcontent: \"\";\n\tbackground: #203f70;\n\ttransition: width 0.4s;\n\tcolor: #203f70 !important;\n}\n\n.login {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tline-height: 38px;\n\tcolor: #494949 !important;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 16px;\n}\n\n.register {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 16px;\n\tflex-direction: row;\n\tjustify-content: center;\n\tpadding: 18px;\n\twidth: 114px;\n\theight: 38px;\n\tbackground: var(--button-background);\n\tborder-radius: 36px;\n\tfont-family: \"Poppins\";\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 24px;\n\tcolor: #000000 !important;\n}\n\n.user-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tposition: relative;\n\tpadding: 0;\n\theight: 1px;\n\tbackground-color: white;\n}\n\n.user-header__content {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 20px;\n\tposition: absolute;\n\ttop: 16px;\n\tright: 24px;\n}\n\n.user-header__switch {\n\twidth: 48px;\n\theight: 24px;\n\tborder-radius: 20px;\n\toverflow: hidden;\n\tposition: relative;\n\tobject-fit: cover;\n\tcursor: pointer;\n}\n\n.user-header__switch-circle {\n\tposition: absolute;\n\tleft: 2px;\n\ttop: 2px;\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 50%;\n\tbackground-color: white;\n\tcursor: pointer;\n}\n\n.user-header__switch-circle.zh {\n\tleft: unset;\n\tright: 2px;\n}\n\n.user-header__switch-circle.en {\n\tleft: 2px;\n}\n\n.user-header__switch-image {\n\twidth: 100%;\n}\n\n.dashboard-header__notifications {\n\twidth: 60px;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid #e6e6e6;\n\tborder-radius: 100%;\n\tbackground-color: white;\n\tcursor: pointer;\n}\n\n.dashboard-header__notifications.notification-unread {\n\tbackground-color: #feeced;\n\tborder: 1px solid #feeced;\n}\n\n.user-header-dropdown,\n.user-header-dropdown.show,\n.user-header-dropdown:active,\n.user-header-dropdown:hover,\n.user-header-dropdown:focus-visible {\n\tbackground-color: transparent !important;\n\tborder: none !important;\n\tbox-shadow: none !important;\n}\n\n.user-header-dropdown::after {\n\tcontent: unset;\n}\n\n.user-header-dropdown-menu {\n\tleft: unset !important;\n\tright: 0% !important;\n}\n\n.notifications-container {\n\tposition: absolute;\n\twidth: 340px;\n\theight: 500px;\n\tbackground-color: #ffffff;\n\tright: 10px;\n\tz-index: 1001;\n\tborder-radius: 10px;\n\ttop: 72px;\n\toverflow: hidden;\n\tborder: 1px solid #e6e6e6;\n\tbox-shadow: 0 0 15px 2px #0c030322;\n}\n\n.notification-body {\n\theight: calc(100% - 57px);\n\toverflow-y: auto;\n\tbackground-color: #ffffff;\n}\n\n.notification-body::-webkit-scrollbar {\n\twidth: 7px;\n\tbackground-color: transparent;\n}\n\n.notification-body::-webkit-scrollbar-thumb {\n\tbackground-color: #333333;\n\tborder-radius: 10px;\n\tmargin-top: 10px;\n}\n\n.notification-body::-webkit-scrollbar-track {\n\tbackground-color: transparent;\n}\n\n.notifications-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 16px;\n\tborder-bottom: 1px solid #e6e6e6;\n}\n\n.notification-block {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: start;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding: 10px;\n\tbackground-color: white;\n\tpadding-bottom: 35px;\n\tposition: relative;\n\tborder-bottom: 1px solid #e6e6e6;\n}\n\n.notification-type-dot {\n\tmin-width: 10px;\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n\tmargin-top: 7px;\n}\n\n.notification-type-dot.info {\n\tbackground-color: #4db8ff;\n}\n\n.notification-type-dot.warning {\n\tbackground-color: #ffc107;\n}\n\n.notification-type-dot.error {\n\tbackground-color: #f44336;\n}\n\n.notification-created-at {\n\tposition: absolute;\n\tleft: 35px;\n\tbottom: 10px;\n\tfont-size: 14px;\n\tcolor: #808080;\n}\n\n.notifications-title {\n\tfont-weight: 500;\n\tfont-size: 20px;\n\tline-height: 24px;\n}\n\n.notification-info {\n\tdisplay: flex;\n\talign-items: start;\n\tgap: 16px;\n\twidth: 90%;\n}\n\n.notification-icon {\n\tmargin-right: 5px;\n\tmargin-top: 1px;\n}\n\n.notification-text {\n\tcolor: #333333;\n\tword-break: break-word;\n}\n\n.notifications-count-block {\n\twidth: 22px;\n\theight: 22px;\n\tbackground-color: #d24023;\n\tcolor: white;\n\tposition: absolute;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 12px;\n\ttop: 5px;\n\tright: 5px;\n\tborder: 1px solid white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
